import { render, staticRenderFns } from "./OrderComments.vue?vue&type=template&id=51d84c4f&scoped=true&"
import script from "./OrderComments.vue?vue&type=script&lang=js&"
export * from "./OrderComments.vue?vue&type=script&lang=js&"
import style0 from "./OrderComments.vue?vue&type=style&index=0&id=51d84c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d84c4f",
  null
  
)

export default component.exports